export const DISPLAY_DEVICES = {
  ALL: 'all',
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};

export const DISPLAY_PAGES_TYPE = {
  ALL: 'all',
  SHOW_SPECIFIC: 'showSpecific',
  HIDE_SPECIFIC: 'hideSpecific'
};

export const DEFAULT_DISPLAY_PAGES_VALUES = [
  'index',
  'product',
  'collection,list-collections',
  'cart',
  'blog,article'
];

export const DEFAULT_DISPLAY_PAGES = {
  type: DISPLAY_PAGES_TYPE.ALL,
  values: []
};

export const CUSTOM_PAGES_FIELD = 'displayPagesCustomPages';
